import { mapCreditFiscal } from './mapCreditFiscal';
import { mapCreditNote } from './mapCreditNote';
import { mapConsumerFinal } from './mapConsumerFinal';
import { mapExportInvoice } from './mapExportInvoice';

import { SaleDetail, SaleFormValues } from '../../../types/sale';
import { DOCUMENT_TYPE_CODES } from '../../../constants/documentTypeCodes';

export const SaleMapperHelper = {
  mapToSaleFormValues(data: SaleDetail): SaleFormValues {
    const code = data.documentType?.code;

    if (!code) {
      throw new Error('El documento no tiene código de tipo');
    }

    switch (code) {
      case DOCUMENT_TYPE_CODES.TAX_CREDIT:
        return mapCreditFiscal(data);

      case DOCUMENT_TYPE_CODES.CREDIT_NOTE:
        return mapCreditNote(data);

      case DOCUMENT_TYPE_CODES.INVOICE:
        return mapConsumerFinal(data);

      case DOCUMENT_TYPE_CODES.EXPORT_INVOICE:
        return mapExportInvoice(data);

      default:
        throw new Error(`Tipo de documento no soportado: ${code}`);
    }
  },
};
